import React from 'react';
import ChatInterface from './ChatInterface';

const ChatPane = ({ neobot, user }) => {
  if (!neobot) {
    return (
      <div className="aim-chat-container" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div className="aim-chat-header">
          <span className="aim-status-indicator aim-status-offline"></span>
          Welcome to NeoBots
        </div>
        <div className="aim-messages-area" style={{ flex: 1 }}>
          <div className="aim-system-message">
            Select a bot from the sidebar to start chatting!
          </div>
        </div>
      </div>
    );
  }

  return <ChatInterface neobot={neobot} user={user} />;
};

export default ChatPane; 